import React, { svg } from 'react'

export default function ScanOverlay () {
  return (
    <svg viewBox='0 0 100 100' className='scanOverlay'>
      <path fill='none' d='M13, 0 L0, 0 L0, 13' stroke='#3f51b5' strokeWidth='3' />
      <path fill='none' d='M0, 87 L0, 100 L13, 100' stroke='#3f51b5' strokeWidth='3' />
      <path fill='none' d='M87, 100 L100, 100 L100, 87' stroke='#3f51b5' strokeWidth='3' />
      <path fill='none' d='M100, 13 L100, 0 87, 0' stroke='#3f51b5' strokeWidth='3' />
    </svg>
  )
}
